
/**
 * Split the list of commands up into an array of chunks.
 * We can then loop through all the commands and treat them accordingly.
 *
 * @return {void}
 */
function lexer( text ) {

	const chunks = [];

	// NOTE: Must remember to edit the content in token default switch statement.
	const allowedChars = /[a-z\-\d\$()#]/i;

	let chunk = '';

	for ( const ch of text ) {

		chunk = chunk.trim();

		if ( ch === ' ' || ch === '{' || ch === '}' ) {

			if ( chunk ) {
				chunks.push( chunk );
			}

			if ( ch !== ' ' ) {
				chunks.push( ch );
			}

			chunk = '';

		} else if ( allowedChars.test( ch ) ) {

			chunk += ch;

		}

	}

	if ( chunk ) {
		chunks.push( chunk );
	}

	return chunks;

}



/**
 * Prepare the program for parsing.
 *
 * @return {void}
 */
function prepareText( text ) {

	if ( !text ) {
		return '';
	}

	// Make lowercase.
	text = text.toLowerCase();

	// Remove comments.
	let lines = text.split( /\r?\n/ );
	lines.forEach(
		( value, index ) => {
			lines[ index ] = value.replace( /\/\/.*/g, '' );
		}
	);
	text = lines.join( ' ' );

	// Remove whitespace (duplicate spaces).
	text.replace( /\s+/g, ' ' );

	return text;

}


